import { get, post, type RequestConfig } from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  GaushalaAddDonationPayload,
  GaushalaDonation,
} from "@project/types/gaushala";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/gaushala-donations`;
const SILENT: RequestConfig = { showNotification: false };

class GaushalaDonationService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<GaushalaDonation>> =>
    fetchListPage<GaushalaDonation>(`${BASE}/`, query);

  get = async (id: number): Promise<GaushalaDonation | undefined> => {
    const data = await get<
      ApiItemResponse<GaushalaDonation> | GaushalaDonation
    >(`${BASE}/${id}/`, SILENT_LIST);
    return unwrapItem(data);
  };

  add = async (
    payload: GaushalaAddDonationPayload
  ): Promise<GaushalaDonation | undefined> => {
    const data = await post<
      ApiItemResponse<GaushalaDonation> | GaushalaDonation,
      GaushalaAddDonationPayload
    >(`${BASE}/add/`, payload, SILENT);
    return unwrapItem(data);
  };
}

export const gaushalaDonationService = new GaushalaDonationService();
